import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ArrowUp from '../Icons/ArrowUp';
import { IconSize } from '../Icons/IconWrap';
import { ThemeOverride } from '../Context/ThemeContext';
import s from './BackToTop.scss';
/** A 'hop to top' button that sends the user back to the top of some scrollable area
 *  This is a simplified version of the original BackToTop that doesn't need to account
 *  for PerspectiveContainers, or BI (yet) but still share the design
 *  elements of the original. */
var SimpleBackToTop = /** @class */ (function (_super) {
    __extends(SimpleBackToTop, _super);
    function SimpleBackToTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // TODO: use this within BackToTop so that it's truly shared
        _this.onClick = function () {
            var _a = _this.props, scrollToY = _a.scrollToY, getScrollableContainer = _a.getScrollableContainer;
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                scrollableContainer.scrollTo({
                    left: 0,
                    top: scrollToY || 0,
                    behavior: 'smooth',
                });
            }
        };
        return _this;
    }
    SimpleBackToTop.prototype.renderButton = function () {
        var _a = this.props, _b = _a.scrolled, scrolled = _b === void 0 ? false : _b, className = _a.className, stuckClassName = _a.stuckClassName;
        return (React.createElement("div", { onClick: this.onClick, className: classnames(s['root'], className, scrolled && s['stuck'], scrolled && stuckClassName) },
            React.createElement(ArrowUp, { disableDefaultColors: true, size: IconSize.SMALL })));
    };
    SimpleBackToTop.prototype.render = function () {
        var forcedTheme = this.props.forcedTheme;
        return forcedTheme ? (React.createElement(ThemeOverride, { theme: forcedTheme }, this.renderButton())) : (this.renderButton());
    };
    return SimpleBackToTop;
}(React.Component));
export default SimpleBackToTop;
//# sourceMappingURL=SimpleBackToTop.js.map